import { useEffect } from "react";
import {
  useDynamicContext,
  useUpgradeToDynamicWaasFlow,
} from "@dynamic-labs/sdk-react-core";
import { useLocation } from "react-router-dom";

import { Paths } from "../../common/constants";
import { MainContainerProps } from "./container.type";

/**
 * Resets review and claim state while wrapping page content in a basic container.
 */
const MainContainer = ({ children }: MainContainerProps) => {
  const { pathname } = useLocation();

  const { user, primaryWallet } = useDynamicContext();
  const { promptUpgradeToDynamicWaasFlow } = useUpgradeToDynamicWaasFlow();

  useEffect(() => {
    const isReviewPath =
      pathname.includes(Paths.REVIEW_LIST) ||
      pathname.includes(Paths.LIBRARY_PRODUCT_REVIEW);

    if (!isReviewPath) {
      localStorage.removeItem("consumerClaimId");
      localStorage.removeItem("isReviewBtnVisible");
      localStorage.removeItem("ratingSerialNumber");
    }

    if (!pathname.includes(Paths.PRODUCT_DETAILS)) {
      localStorage.removeItem("scratchOffCode");
      localStorage.removeItem("serialNumber");
    }
  }, [pathname]);

  useEffect(() => {
    if (!user || !primaryWallet) return;

    const runMigration = async () => {
      await new Promise((res) => setTimeout(res, 1500));

      if (primaryWallet.key !== "dynamicwaas") {
        promptUpgradeToDynamicWaasFlow();
      }
    };

    runMigration();

    // eslint-disable-next-line
  }, [user?.userId, primaryWallet?.id]);

  return <div className="PwaMainContainer">{children}</div>;
};

export default MainContainer;
